// Map state
export const center = state => {
  return state.center ? [state.center.lng, state.center.lat] : null
}
export const zoom = state => state.zoom

// geolocation
export const position = state => state.position

// Weather
export const weather = state => state.weather

// POIs
export const poisTrack = state => state.poisTrack

export const poi = state => id => {
  return state.pois[id]
}

export const pois = state => {
  return state.poisIdx.map(id => state.pois[id])
}
